import { render, staticRenderFns } from "./emba-overview.vue?vue&type=template&id=4447369e&scoped=true"
import script from "./emba-overview.vue?vue&type=script&lang=ts"
export * from "./emba-overview.vue?vue&type=script&lang=ts"
import style0 from "./emba-overview.vue?vue&type=style&index=0&id=4447369e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4447369e",
  null
  
)

export default component.exports